// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2t3vK","label":"SetPasswdForm_label__1uqTh"};